import React from 'react';

export const TableHeader = ({ UImobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="180px">
            <span>Дата</span>
        </th>
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="auto">
            <span>Филиал</span>
        </th>
        <th
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}
            style={{ textAlign: 'center' }}
            width="180px"
        >
            <span>Статус</span>
        </th>
        <th
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}
            style={{ textAlign: 'right' }}
            width="180px"
        >
            <span>Действия</span>
        </th>
    </tr>
    </thead>
);